var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.664062,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.664062,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#070707",
    strokeOpacity: 0.08,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6637 19L14.6641 15M14.6645 19L18.6641 15",
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 17.0002C23.3333 13.3183 20.3485 10.3335 16.6667 10.3335C12.9848 10.3335 10 13.3183 10 17.0002C10 20.682 12.9848 23.6668 16.6667 23.6668C20.3485 23.6668 23.3333 20.682 23.3333 17.0002Z",
    stroke: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentPending);
export default __webpack_public_path__ + "static/media/student_pending.d6fae9b1eb3fd2ee300a24973745b759.svg";
export { ForwardRef as ReactComponent };